import { appInsights } from './src/AppInsights';

export const onRouteUpdate = () => {
  if (appInsights) {
    appInsights.trackPageView();
  }
};
